import { useQuery } from '@tanstack/react-query'
import { data } from '@portal/pkg-api/shared'
import { EntityTypeApi } from '@portal/pkg-api/navigator'
import { EntityType } from '@portal/pkg-api/gen/navigator'

const prefix = 'navigator.entityType'

export const EntityTypeQueries = {
  entityTypes: () => ({
    queryKey: [`${prefix}.entityTypes`],
    queryFn: () => data(EntityTypeApi.getEntityTypes()),
  }),
  // TODO: This is a pretty bad query, should just be a `useMemo()`.
  entityType: (entityTypes?: EntityType[], entityTypeId?: number) => ({
    queryKey: [`${prefix}.entityType`, entityTypeId],
    queryFn: () => entityTypes!.find(({ id }) => id === entityTypeId),
    enabled: !!entityTypeId && !!entityTypes,
  }),
}

export function useEntityTypes() {
  return useQuery(EntityTypeQueries.entityTypes())
}

export function useEntityType(entityTypeId?: number) {
  const { data: entityTypes } = useEntityTypes()
  return useQuery(EntityTypeQueries.entityType(entityTypes, entityTypeId))
}
